export default __webpack_public_path__ + "1b97f5890d1fdd42e0de07eaa72d841e.png";